import React, { useEffect, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

import { BorderProps } from "components/common/LocationFields/LocationFields.types";

import { useAppDispatch, useAppSelector } from "store/hooks";
import { fetchUserPosts } from "store/userPosts/userPosts.actions";
import {
  PostCard,
  PostTitle,
  PostsContainer,
  RenderView,
  SelectedContainer,
  SelectedLabel,
  SelectedPosts,
  StyledImg,
  Thumb,
  Track
} from "./index.styles";

import { selectUserPosts } from "store/userPosts/userPosts.selectors";
import { PostToSelect, SelectedPostId } from "store/userPosts/userPosts.types";

interface PostsSelectorProps {
  selectedPostIds: SelectedPostId[];
  setSelectedPostIds: (posts: SelectedPostId[]) => void;
  disabled?: boolean;
  border?: BorderProps;
  maxWidth?: string;
}


const PostsSelector: React.FC<PostsSelectorProps> = ({
  selectedPostIds,
  setSelectedPostIds,
  disabled = false,
  border,
  maxWidth
}) => {
  const [trailPosition, setTrailPosition] = useState(0);
  const posts = useAppSelector(selectUserPosts);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchUserPosts());
  }, []);

  const handleSelection = (postId: SelectedPostId) => {
    if (disabled) return;
    if (selectedPostIds.includes(postId)) {
      const newSelectedPostIds = selectedPostIds.filter(id => id !== postId);
      setSelectedPostIds(newSelectedPostIds);
    } else {
      const newSelectedPostIds = [...selectedPostIds, postId];
      setSelectedPostIds(newSelectedPostIds);
    }
  };

  const handleScrollFrame = (e: { left: number }) => {
    setTrailPosition(e.left);
  };

  return (
    <PostsContainer border={border} maxWidth={maxWidth}>
      <SelectedContainer>
        {selectedPostIds.length > 0 ? (
          <SelectedLabel>Selected: </SelectedLabel>
        ) : (
          <SelectedLabel>No posts selected</SelectedLabel>
        )}
        {selectedPostIds.map((selectedId, key) => {
          const foundPost = posts.find((post) => post.id === selectedId);
          if (!foundPost) return null;
          return (
            <SelectedPosts key={key}>
              {foundPost.post_caption}
            </SelectedPosts>
          );
        })}
      </SelectedContainer>
      <Scrollbars
        style={{ overflow: "visible" }}
        renderView={({ style, ...props }: any) => <RenderView {...props} />}
        renderThumbHorizontal={({ style, ...props }: any) => (
          <Thumb
            {...props}
            style={{
              left: `${100 - 100 * trailPosition < 16.08 ? 10 : 0}px`,
            }}
          />
        )}
        renderTrackHorizontal={({ style, ...props }: any) => (
          <Track
            {...props}
            $trailPosition
            style={{
              background: `linear-gradient(to left, white ${100 - 100 * trailPosition < 81
                ? 100 - 100 * trailPosition + 1
                : 100 - 100 * trailPosition
                }%, #FE2F67 0%)`,
            }}
          />
        )}
        thumbSize={20}
        onScrollFrame={(e: { left: number }) => handleScrollFrame(e)}
      >
        {posts.map((post: PostToSelect, key) => (
          <PostCard key={key}>
            <StyledImg
              src={post.image_url}
              width="170"
              height="125"
              style={{
                outline: selectedPostIds.includes(post.id) ? "10px solid pink" : "",
                opacity: disabled ? 0.5 : 1,
                cursor: disabled ? "not-allowed" : "pointer",
              }}
              onClick={() => handleSelection(post.id)}
            />
            <PostTitle>{post.post_caption}</PostTitle>
          </PostCard>
        ))}
      </Scrollbars>
    </PostsContainer>
  );
};

export default PostsSelector;